module.exports = __webpack_public_path__ + "static/media/whatsapp-dark-blue.7f0cf43d.svg";